const Aggression = require("../../entities/Aggression")
const { Age } = require('../Constants');
const AggessionNames = require("../Names/AggressionNames");

class Enslave extends Aggression {
    constructor() {
        super(
            Age.Age1,
            AggessionNames.Enslave,
            2,
            "Your rival loses 1 population. You gain 2 food and 2 resources.",
            {
                //effect
            }
        )
    }
}

module.exports = Enslave;